import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import {
  SuperAdminLogin,
  SuperAdminDashboard,
  SuperAdminHome,
  SuperAdminDashboards,
  SuperAdminClientEditProfile,
  ClientList,
  SuperAdminSettings,
  AddClient,
  ClientCampaigns,
  ClientMembers,
  ClientPrograms,
  ClientInsights,
  SuperAdminEditProfile,
  TermsAndConditions,
} from "./pages/superadmin";
import {
  ClientLogin,
  ClientSignup,
  ClientDashboard,
  Home,
  Dashboards,
  Campaigns,
  Insights,
  Inbox,
  ClientSetUpPassword,
  Progrmas,
  Users,
  CreateUser,
  EditProfile,
  ClientForgetPassword,
  ViewTermsAndConditions,
  PaidSocial,
  OwnedMedia,
  PaidMedia,
  Search,
  ListAdsWithinCampaigns,
  Ads,
  DashboardsHome,
} from "./pages/client/index";
import { NestedRouteOutlet, EditAdminProfile } from "./components";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Integrations from "./pages/client/integrations/Integrations";
import LinkCampaigns from "./pages/client/integrations/LinkCampaigns";
import SuperAdminHomeDev from "./pages/superadmin/SuperAdminHomeDev";
import GoogleAnalytics from "./pages/client/integrations/GoogleAnalytics";
import { useRef, useEffect } from "react";
import gsap from "gsap";
import CampaignsViewMore from "./pages/client/campaigns/CampaignsViewMore";
import LinkOrganicSocial from "./pages/client/settings/LinkOrganicSocial";
import GoogleAlalyticsList from "./pages/client/google-analytics/GoogleAlalyticsList";
import OrganicSocialList from "./pages/client/organic-social/OrganicSocialList";
import OrganicSocialViewMore from "./pages/client/organic-social/OrganicSocialViewMore";
import GoogleAnalyticsViewMore from "./pages/client/google-analytics/GoogleAnalyticsViewMore";

import NewDashboardHome from "./pages/client/dashboard/new_dashboard/NewDashboardHome";
import PaymentsPage from "./pages/client/settings/PaymentsPage";
import ReportsAnalytics from "./pages/client/reports-analytics/ReportsAnalytics";

function App() {
  const navbarRef = useRef(null);
  const sidebar = useRef(null);
  const contentRef = useRef(null);

  return (
    <div className="main ">
      <ToastContainer />
      <Routes>
        <Route path="/client/login" element={<ClientLogin />} />
        <Route path="/client/signup" element={<ClientSignup />} />
        <Route index element={<ClientLogin />} />
        <Route
          path="/client/terms_and_conditions"
          element={<ViewTermsAndConditions />}
        />
        <Route
          path="/client/forget_password"
          element={<ClientForgetPassword />}
        />
        <Route
          path="/client/forget_password/:forget_password_token"
          element={<ClientForgetPassword />}
        />
        <Route path="/super_admin/login" element={<SuperAdminLogin />} />
        <Route
          path="/client/setup_password/:setup_password_token"
          element={<ClientSetUpPassword />}
        />
        <Route
          path="/client"
          element={
            <ClientDashboard
              navbarRef={navbarRef}
              sidebar={sidebar}
              contentRef={contentRef}
            />
          }
        >
          <Route path="/client/" element={<Home />} />
          <Route path="dashboards" element={<Dashboards />}>
            <Route index path="home" element={<DashboardsHome />} />
            {/* <Route index path="home" element={<NewDashboardHome />} /> */}

            <Route path="paid_social" element={<PaidSocial />} />
            <Route path="organic_social" element={<OwnedMedia />} />
            <Route path="paid_media" element={<PaidMedia />} />
            <Route path="owned_media" element={<GoogleAlalyticsList />} />
            <Route
              path="owned_media/view-more"
              element={<GoogleAnalyticsViewMore />}
            />
          </Route>
          <Route path="campaigns" element={<Campaigns />} />
          <Route
            path="campaigns/view-more/:ads_id/:platform_id"
            element={<CampaignsViewMore />}
          />
          <Route
            path="campaigns/:external_campaign_id/:platform_id"
            element={<ListAdsWithinCampaigns />}
          />
          <Route
            path="track-google-analytics"
            element={<GoogleAlalyticsList />}
          />
          <Route
            path="track-google-analytics/view-more"
            element={<GoogleAnalyticsViewMore />}
          />

          <Route path="organic-social" element={<OrganicSocialList />} />
          <Route
            path="organic-social/view-more/:post_id/:platform_id"
            element={<OrganicSocialViewMore />}
          />

          <Route path="programs" element={<Progrmas />} />
          <Route path="list_ads" element={<Ads />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="insights" element={<Insights />} />
          <Route path="reprots_analytics" element={<ReportsAnalytics />} />
          <Route path="integrations" element={<IntegrationsRedirect />} />
          <Route path="settings" element={<NestedRouteOutlet />}>
            <Route path="client_profile" element={<EditProfile />} />
            <Route path="user_profile" element={<EditAdminProfile />} />
            <Route path="security" element={<EditAdminProfile />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:user_id" element={<CreateUser />} />
            <Route path="add_user" element={<CreateUser />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="link-ads" element={<LinkCampaigns />} />
            <Route path="link-organic-social" element={<LinkOrganicSocial />} />
            <Route path="analytics" element={<GoogleAnalytics />} />
          </Route>
        </Route>

        <Route
          path="/super_admin"
          element={
            <SuperAdminDashboard
              navbarRef={navbarRef}
              sidebar={sidebar}
              contentRef={contentRef}
            />
          }
        >
          {/* <Route path="/super_admin/" element={<SuperAdminHome />} /> */}
          <Route path="/super_admin/" element={<SuperAdminHomeDev />} />
          <Route path="home_dev/" element={<SuperAdminHomeDev />} />
          <Route path="dashboards" element={<SuperAdminDashboards />} />
          <Route path="profile" element={<SuperAdminClientEditProfile />} />
          <Route path="add_client" element={<AddClient />} />
          <Route path="edit_profile" element={<SuperAdminEditProfile />} />

          <Route path="clients" element={<ClientList />} />
          <Route path="clients/:client_id" element={<NestedRouteOutlet />}>
            <Route path="" element={<SuperAdminClientEditProfile />} />
            <Route path="members" element={<ClientMembers />} />
            <Route path="campaigns" element={<ClientCampaigns />} />
            <Route path="programs" element={<ClientPrograms />} />
            <Route path="insights" element={<ClientInsights />} />
            <Route
              path="terms_and_conditions"
              element={<TermsAndConditions />}
            />

            <Route
              path="integrations"
              element={<SuperAdminClientEditProfile />}
            />
          </Route>

          <Route path="settings" element={<SuperAdminSettings />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;

const IntegrationsRedirect = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get("code");

  if (code) {
    // Perform the redirection with the code parameter
    return <Navigate to={`/client/settings/integrations?code=${code}`} />;
  }

  // If there's no code parameter, render a default component (or handle accordingly)
  return <div>No code provided</div>;
};
